import script from "./VCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./VCheckbox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__